import React, { Component } from "react";
import { Link } from "react-router-dom";
import Keen from "keen-js";
import { Grid, Row, Col, Table } from "react-bootstrap";
import moment from "moment";
import "moment/locale/pt-br";
import _ from "lodash";
import { object } from "prop-types";

// utils
import { formatNumber, formatPercentage } from "../utils/numeral";
import { createQuery, runQuery } from "../utils/KeenReport";

// components
import TimeframeChooser from "./TimeframeChooser";
import Spinner from "./Spinner";

class AccountReport extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      hasError: false,
      videos: [],
      totalRecommends: 0,
      totalPlays: 0
    };

    this.runKeen = this.runKeen.bind(this);
  }
  componentDidMount() {
    this.runKeen(this.props);
  }
  componentWillReceiveProps(nextProps) {
    if (
      nextProps.timeframeChooser.timeframe !==
      this.props.timeframeChooser.timeframe
    ) {
      this.runKeen(nextProps);
    }
  }
  runKeen(props) {
    Keen.ready(() => {
      let { campaigns, timeframeChooser } = props;
      let queries;
      let videos = [];
      let videoIds = [];
      campaigns.forEach(campaign => {
        campaign.videos.forEach(video => {
          video.plays = 0;
          video.recommends = 0;
          // video.conversions = 0
          video.campaign = campaign.name;
          video.campaign_id = campaign.id;
          videos.push(video);
          videoIds.push(video.id);
        });
      });
      console.log(videoIds);
      this.setState({
        isLoading: true,
        hasError: false
      });
      queries = [
        createQuery(
          "count",
          "video_recomended",
          timeframeChooser.timeframe,
          null,
          null,
          null,
          null,
          [
            {
              operator: "in",
              property_name: "video_id",
              property_value: videoIds
            }
          ],
          ["video_id"]
        ),
        createQuery(
          "count",
          "video_unique_click",
          timeframeChooser.timeframe,
          null,
          null,
          null,
          null,
          [
            {
              operator: "in",
              property_name: "video_id",
              property_value: videoIds
            }
          ],
          ["video_id"]
        )
        // createQuery('count', 'user_interacted', timeframe, null, null, null, null, [{
        //   'operator': 'in',
        //   'property_name': 'video_id',
        //   'property_value': videoIds
        // }], ['video_id'])
      ];
      runQuery(queries).then(
        res => {
          let videoListResultRecomends = res[0].result;
          let videoListResultPlays = res[1].result;
          let totalRecommends = 0;
          let totalPlays = 0;
          // let videoListResultConversions = res[2].result

          // Populate Recomends
          videos.forEach(video => {
            videoListResultRecomends.forEach(videoResult => {
              if (video.id === videoResult.video_id) {
                video.recommends = videoResult.result;
              }
            });
          });

          // Populate Plays
          videos.forEach(video => {
            videoListResultPlays.forEach(videoResult => {
              if (video.id === videoResult.video_id) {
                video.plays = videoResult.result;
              }
            });
          });

          videos.forEach(video => {
            video.playrate = video.plays / video.recommends;
            totalRecommends += video.recommends;
            totalPlays += video.plays;
          });

          // Populate Conversions
          // videos.forEach((video) => {
          //   videoListResultConversions.forEach((videoResult) => {
          //     if (video.id === videoResult.video_id) {
          //       video.conversions = videoResult.result
          //     }
          //   })
          // })

          videos = _.orderBy(videos, ["recommends"], ["desc"]);

          this.setState({
            isLoading: false,
            hasError: false,
            videos: videos,
            totalRecommends,
            totalPlays
          });
        },
        err => {
          console.log("Erro rodando a query do Keen.", err);
          this.setState({
            hasError: true
          });
        }
      );
    });
  }
  render() {
    let {
      isLoading,
      hasError,
      videos,
      totalRecommends,
      totalPlays
    } = this.state;
    const { timeframeChooser } = this.props;
    return (
      <Grid>
        <Row>
          <Col md={12}>
            <div className="page-header">
              <Row>
                <Col md={5}>
                  <h2 className="mt26">
                    Relatório:{" "}
                    {`${moment(timeframeChooser.startDate).format(
                      "DD/MM"
                    )} a ${moment(timeframeChooser.endDate).format("DD/MM")}`}
                  </h2>
                </Col>
                <Col md={7}>
                  <TimeframeChooser />
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <Table className={isLoading ? "hidden" : "accountReport-table"}>
              <thead>
                <tr>
                  <th>Video</th>
                  <th>Campanha</th>
                  <th className="text-right">Recomendações</th>
                  <th className="text-right">Plays</th>
                  <th className="text-right">Play rate</th>
                  {/* <th className='text-right'>Clicks</th> */}
                  <th />
                </tr>
              </thead>
              <tbody>
                {videos.map(video => (
                  <tr key={video.id}>
                    <td>{video.title}</td>
                    <td>{video.campaign}</td>
                    <td className="text-right">
                      {formatNumber(video.recommends)}
                    </td>
                    <td className="text-right">{formatNumber(video.plays)}</td>
                    <td className="text-right">
                      {formatPercentage(video.playrate)}
                    </td>
                    {/* <td className='text-right'>{formatNumber(video.conversions)}</td> */}
                    <td className="text-right">
                      <Link to={`/campaigns/${video.campaign_id}/stats`}>
                        <button className="btn btn-sm btn-primary">
                          ver estatísticas
                        </button>
                      </Link>
                    </td>
                  </tr>
                ))}
                <tr style={style.lastLine}>
                  <td colSpan="2">Total:</td>
                  <td className="text-right">
                    {formatNumber(totalRecommends)}
                  </td>
                  <td className="text-right">{formatNumber(totalPlays)}</td>
                  <td colSpan="2" />
                </tr>
              </tbody>
            </Table>
            <Spinner
              isLoading={isLoading}
              hasError={hasError}
              runKeen={() => {
                this.runKeen(this.props);
              }}
            />
          </Col>
        </Row>
      </Grid>
    );
  }
}

var style = {
  lastLine: {
    backgroundColor: "#ddd",
    fontWeight: "bold"
  }
};

AccountReport.propTypes = {
  timeframeChooser: object
};

export default AccountReport;



// WEBPACK FOOTER //
// ./src/components/AccountReport.js